import { CustomTimestamps } from 'chessboard/api/custom-timestamps/config/types';

/**
 * Convert a time to rounded deciseconds.
 */
export function toRoundedDeciseconds(time: number, unit: CustomTimestamps.Units): number {
  let deciseconds: number;

  switch (unit) {
    case CustomTimestamps.Units.Milliseconds:
      deciseconds = time / 100;
      break;
    case CustomTimestamps.Units.Seconds:
      deciseconds = time * 10;
      break;
    case CustomTimestamps.Units.Deciseconds:
    default:
      deciseconds = time;
      break;
  }

  return Math.round(deciseconds);
}
